export default __webpack_public_path__ + "navigation-examples-route-init-v1-1200-29cc91f7333bfc67e4a644a519c977ea.png";